import React from 'react';

interface QuantityInputProps {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    step?: number;
    disabled?: boolean;
}

const QuantityInput: React.FC<QuantityInputProps> = ({ value, onChange, min = 0, max, step = 1, disabled = false }) => {
    
    const handleIncrement = () => {
        if (disabled) return;
        if (max !== undefined && value >= max) return;
        onChange(value + step);
    };

    const handleDecrement = () => {
        if (disabled) return;
        if (value > min) {
             onChange(value - step);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = parseInt(e.target.value) || 0;
        onChange(val);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const val = parseInt(e.target.value);
         if (val < min || isNaN(val)) {
             onChange(min);
         } else if (max !== undefined && val > max) {
             onChange(max);
         }
    };

    return (
        <div className="input-group">
            <button 
                className="btn btn-outline-secondary me-0" 
                type="button" 
                onClick={handleDecrement}
                disabled={disabled || value <= min}
            >
                <i className="fa-solid fa-minus"></i>
            </button>
            <input
                type="number"
                className="form-control text-center"
                value={value}
                min={min}
                max={max}
                step={step}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
            />
            <button 
                className="btn btn-outline-secondary" 
                type="button" 
                onClick={handleIncrement}
                disabled={disabled || (max !== undefined && value >= max)}
            >
                <i className="fa-solid fa-plus"></i>
            </button>
        </div>
    );
};

export default QuantityInput;
